/* Naughty Hut smart brand finder, 2026-09-25. Used by the mega menu, the phone menu and /collections/brands.

   Two layers:
   1. Instant, local: brand names matched by prefix, substring, known aliases (e.g. "hitachi" -> Magic Wand)
      and typo tolerance ("satisfier", "womaniser", "calexotic").
   2. Live: Shopify predictive search (/search/suggest.json) turns a product word ("rabbit", "lube",
      "sex machine") into the brands that actually make it here (ranked by matching products), a
      category shortcut, and the top matching products with photo and price.

   Markup contract inside any [data-nhb]:
     input[data-nhb-input]      the search box
     [data-nhb-item]            one brand; data-name = searchable name; contains an <a href="/collections/<handle>">
     [data-nhb-group]           optional wrapper, hidden when none of its items match
     [data-nhb-idle]            shown only while the box is empty
     [data-nhb-results]         shown only while searching
     [data-nhb-empty]           shown when nothing at all matches; [data-nhb-q] gets the query text,
                                a[data-nhb-search] gets /search?q=<query>
     [data-nhb-count]           receives the number of brand matches
     [data-nhb-smart]           receives the smart results (optional)
   data-nhb-limit caps how many brand names are shown; data-nhb-products how many products (default 4). */
(function () {
  'use strict';
  if (window.nhBrandSearch) return;
  window.nhBrandSearch = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* nicknames, old names, company names and common misspellings -> collection handle */
  var ALIAS = {
    hitachi: 'magic-wand', hitachimagicwand: 'magic-wand', vibratex: 'magic-wand', magicwandoriginal: 'magic-wand', magicwandplus: 'magic-wand',
    lovehoney: 'happy-rabbit', happyrabbits: 'happy-rabbit',
    jo: 'jo', systemjo: 'jo', systemjolube: 'jo',
    ae: 'adam-eve', adamandeve: 'adam-eve', adameve: 'adam-eve',
    californiaexotics: 'calexotics', californiaexoticnovelties: 'calexotics', calexotic: 'calexotics', calex: 'calexotics',
    evolvednovelties: 'evolved', pipedreamproducts: 'pipedream', doxymassager: 'doxy', doxywand: 'doxy',
    thebodywand: 'bodywand', bodywandmassager: 'bodywand', pjurlube: 'pjur', wevibe: 'we-vibe', wevibes: 'we-vibe',
    womaniser: 'womanizer', satisfier: 'satisfyer', satisfy: 'satisfyer', funfactorygermany: 'fun-factory',
    tengaegg: 'tenga', autoblowai: 'autoblow', hismithsexmachine: 'hismith', kiiroofeelstars: 'kiiroo'
  };
  /* predictive-search vendor names that differ from the brand collection title */
  var VENDOR = { jo: 'jo', systemjo: 'jo', shots: 'shots-toys', shotstoys: 'shots-toys', blush: 'blush-novelties', blushnovelties: 'blush-novelties', evolvednovelties: 'evolved', pipedreamproducts: 'pipedream', calexoticsnovelties: 'calexotics' };

  var norm = function (s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
  };
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var handleOf = function (href) { var m = /\/collections\/([^/?#]+)/.exec(href || ''); return m ? m[1] : ''; };

  /* Damerau-Levenshtein distance with an early exit once it exceeds max */
  var dist = function (a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var best = i;
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], prev2[j - 2] + 1);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  };
  /* 2026-09-26: no typo tolerance under 5 letters. At 4 letters one edit is 25% of the word, which made
     "lelo" (not stocked) suggest "Selopa". Short nicknames are handled by ALIAS instead. */
  var tolerance = function (q) { return q.length >= 7 ? 2 : q.length >= 5 ? 1 : 0; };

  /* 2026-09-26: filler words dropped before matching, so natural phrases work:
     "brands that make rabbit vibrators" -> "rabbit vibrators". Only dropped when something is left. */
  var FILLER = { brands: 1, brand: 1, that: 1, make: 1, makes: 1, made: 1, by: 1, who: 1, sells: 1, sell: 1,
    'for': 1, the: 1, a: 1, an: 1, of: 1, 'with': 1, which: 1, what: 1, do: 1, does: 1 };
  var stripFiller = function (raw) {
    var words = (raw || '').split(/\s+/).filter(Boolean);
    var kept = words.filter(function (w) { return !FILLER[w.toLowerCase().replace(/[^a-z]/g, '')]; });
    return kept.length ? kept.join(' ') : raw;
  };
  /* how close q is to a brand name: exact prefix of the same length, the whole name, or any single word */
  var fuzzy = function (q, item) {
    var t = tolerance(q); if (!t) return 99;
    var n = item._nhb, L = q.length;
    /* same-length prefix, plus one letter longer/shorter to catch a missed or doubled letter mid-typing */
    var best = Math.min(dist(q, n.slice(0, L), t), dist(q, n.slice(0, L + 1), t), dist(q, n.slice(0, L - 1), t));
    best = Math.min(best, dist(q, item._nhb, t));
    item._words.forEach(function (w) { best = Math.min(best, dist(q, w, t), dist(q, w.slice(0, q.length), t)); });
    return best <= t ? best : 99;
  };

  var el = function (tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
  var money = function (p) {
    var n = parseFloat(p); if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  };
  var sized = function (url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  };

  var cache = {};
  var suggest = function (q, signal) {
    if (cache[q]) return Promise.resolve(cache[q]);
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last';
    return fetch(url, { signal: signal, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { cache[q] = (d.resources && d.resources.results) || {}; return cache[q]; });
  };

  /* 2026-10-04 (HTML weight): the phone drawer's brand finder is now inserted after the drawer's first open
     (sections/nh-drawer-panels via the Section Rendering API), so binding is per box, once, and re-run on
     'nh:drawer-panels'. */
  var bind = function (box) {
    if (box.__nhbBound) return;
    var input = box.querySelector('[data-nhb-input]');
    if (!input) return;
    box.__nhbBound = true;
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-nhb-item]'));
    var groups = box.querySelectorAll('[data-nhb-group]');
    var smart = box.querySelector('[data-nhb-smart]');
    var limit = parseInt(box.getAttribute('data-nhb-limit'), 10) || 0;
    var maxProducts = parseInt(box.getAttribute('data-nhb-products'), 10) || 4;
    var byHandle = {};
    /* logos already on the page (top-brand tiles), reused for the smart brand chips */
    var logos = {};
    each(box.querySelectorAll('a[href*="/collections/"] img.nhb-logo'), function (img) {
      logos[handleOf(img.closest('a').getAttribute('href'))] = img.currentSrc || img.src;
    });
    items.forEach(function (it) {
      var name = it.getAttribute('data-name') || it.textContent;
      it._nhb = norm(name);
      it._words = name.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2; }).map(norm);
      it._a = it.tagName === 'A' ? it : it.querySelector('a');
      it._handle = handleOf(it._a && it._a.getAttribute('href'));
      it._name = name;
      byHandle[it._handle] = it;
    });
    var brandFromVendor = function (v) {
      var n = norm(v);
      var h = VENDOR[n] || ALIAS[n];
      if (h && byHandle[h]) return byHandle[h];
      for (var i = 0; i < items.length; i++) if (items[i]._nhb === n) return items[i];
      for (i = 0; i < items.length; i++) if (n.length > 3 && (items[i]._nhb.indexOf(n) === 0 || n.indexOf(items[i]._nhb) === 0)) return items[i];
      return null;
    };

    var best = null, timer = null, ctrl = null, seq = 0, localCount = 0;

    var setEmpty = function (show, raw) {
      each(box.querySelectorAll('[data-nhb-empty]'), function (e) { e.hidden = !show; });
      each(box.querySelectorAll('[data-nhb-q]'), function (e) { e.textContent = raw; });
      each(box.querySelectorAll('a[data-nhb-search]'), function (a) { a.href = ROOT + 'search?q=' + encodeURIComponent(raw); });
    };

    /* the store's search always returns something; keep only results that relate to the words typed */
    var relevant = function (sq, text) {
      var toks = sq.toLowerCase().split(/[^a-z0-9]+/).filter(function (t) { return t.length > 1; }).map(norm);
      if (!toks.length) return true;
      var words = (text || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(norm);
      var joined = words.join('');
      return toks.every(function (t) {
        if (joined.indexOf(t) !== -1) return true;
        var tol = tolerance(t);
        return tol > 0 && words.some(function (w) { return dist(t, w, tol) <= tol || dist(t, w.slice(0, t.length), tol) <= tol; });
      });
    };
    var renderSmart = function (raw, res, fuzzyPick, sq) {
      if (!smart) return false;
      if (res) {
        sq = sq || raw;
        res = {
          products: (res.products || []).filter(function (p) { return relevant(sq, [p.title, p.vendor, p.type || p.product_type, (p.tags || []).join(' ')].join(' ')); }),
          collections: (res.collections || []).filter(function (c) { return relevant(sq, c.title); })
        };
      }
      smart.textContent = '';
      var shownHandles = {};
      items.forEach(function (it) { if (!it.hidden) shownHandles[it._handle] = 1; });
      var any = false;

      if (fuzzyPick) {
        var dym = el('p', 'nhb-smart__dym', 'Did you mean ');
        var a = el('a', null, fuzzyPick._name); a.href = fuzzyPick._a.href;
        dym.appendChild(a); dym.appendChild(document.createTextNode('?'));
        smart.appendChild(dym); any = true;
      }
      if (res) {
        /* brands that make what was typed, ranked by how many of the matching products are theirs */
        var tally = {}, order = [];
        (res.products || []).forEach(function (p) {
          var it = brandFromVendor(p.vendor);
          if (!it) return;
          if (!tally[it._handle]) { tally[it._handle] = { it: it, n: 0 }; order.push(it._handle); }
          tally[it._handle].n++;
        });
        var brands = order.map(function (h) { return tally[h]; })
          .filter(function (b) { return !shownHandles[b.it._handle]; })
          .sort(function (x, y) { return y.n - x.n; }).slice(0, 6);
        var cols = (res.collections || []).filter(function (c) { return !byHandle[c.handle]; }).slice(0, 2);
        if (brands.length || cols.length) {
          var sec = el('div', 'nhb-smart__sec');
          sec.appendChild(el('p', 'nhb-smart__h', localCount ? 'Also making \u201c' + raw + '\u201d' : 'Brands for \u201c' + raw + '\u201d'));
          var chips = el('div', 'nhb-smart__chips');
          cols.forEach(function (c) {
            var ca = el('a', 'nhb-smart__chip nhb-smart__chip--cat', 'Shop ' + c.title + ' \u2192'); ca.href = c.url;
            chips.appendChild(ca);
          });
          brands.forEach(function (b) {
            var ba = el('a', 'nhb-smart__chip'); ba.href = b.it._a.href;
            if (logos[b.it._handle]) { var im = el('img'); im.src = logos[b.it._handle]; im.alt = ''; im.loading = 'lazy'; ba.appendChild(im); }
            ba.appendChild(el('span', null, b.it._name));
            chips.appendChild(ba);
          });
          sec.appendChild(chips); smart.appendChild(sec); any = true;
        }
        var prods = (res.products || []).slice(0, maxProducts);
        if (prods.length) {
          var ps = el('div', 'nhb-smart__sec');
          ps.appendChild(el('p', 'nhb-smart__h', 'Top matches'));
          var ul = el('ul', 'nhb-smart__prods'); ul.setAttribute('role', 'list');
          prods.forEach(function (p) {
            var li = el('li'), pa = el('a', 'nhb-smart__prod'); pa.href = p.url;
            var src = (p.featured_image && p.featured_image.url) || p.image;
            var im = el('img'); im.src = sized(src, 160); im.alt = ''; im.loading = 'lazy'; im.width = 64; im.height = 64;
            var tx = el('span', 'nhb-smart__ptxt');
            tx.appendChild(el('span', 'nhb-smart__pv', p.vendor || ''));
            tx.appendChild(el('span', 'nhb-smart__pt', p.title));
            tx.appendChild(el('span', 'nhb-smart__pp', money(p.price)));
            pa.appendChild(im); pa.appendChild(tx); li.appendChild(pa); ul.appendChild(li);
          });
          ps.appendChild(ul);
          var all = el('a', 'nhb-smart__all', 'See all results for \u201c' + raw + '\u201d \u2192');
          all.href = ROOT + 'search?q=' + encodeURIComponent(raw);
          ps.appendChild(all);
          smart.appendChild(ps); any = true;
        }
      }
      smart.hidden = !any;
      return any;
    };

    var clearSmart = function () { if (smart) { smart.hidden = true; smart.textContent = ''; } };

    var run = function () {
      var typed = input.value.trim();
      var raw = stripFiller(typed);
      var q = norm(raw);
      localCount = items.length;
      best = null;
      var fuzzyPick = null, sq = raw;
      clearTimeout(timer);
      /* a newer query always wins: abort the in-flight request and drop the previous query's results */
      seq++;
      if (ctrl) { ctrl.abort(); ctrl = null; }
      box.classList.remove('is-loading');
      clearSmart();

      if (!q) {
        items.forEach(function (el) { el.hidden = false; el.style.order = ''; });
        if (smart) { smart.hidden = true; smart.textContent = ''; }
      } else {
        /* 1. prefix, 2. alias, 3. substring, 4. typo-tolerant */
        var pre = [], mid = [], fz = [], alias = ALIAS[q] && byHandle[ALIAS[q]];
        items.forEach(function (it) {
          var i = it._nhb.indexOf(q);
          if (i === 0) pre.push(it);
          else if (it === alias) pre.unshift(it);
          else if (i > 0) mid.push(it);
          else { var d = fuzzy(q, it); if (d < 99) { it._d = d; fz.push(it); } }
        });
        if (alias && pre.indexOf(alias) === -1) pre.unshift(alias);
        var q0 = q.charAt(0);
        fz.sort(function (x, y) {
          return (x._d - y._d) || ((x._nhb.charAt(0) !== q0) - (y._nhb.charAt(0) !== q0)) || (items.indexOf(x) - items.indexOf(y));
        });
        /* typo matches only when nothing matched properly ("lube" must not suggest "Liberator") */
        var hits = (pre.length || mid.length) ? pre.concat(mid) : fz;
        items.forEach(function (it) { if (hits.indexOf(it) === -1) it.hidden = true; });
        hits.forEach(function (it, k) {
          it.hidden = !!(limit && k >= limit);
          it.style.order = String(k - hits.length); /* keeps rank order inside grid/flex lists */
        });
        localCount = limit ? Math.min(hits.length, limit) : hits.length;
        best = hits[0] || null;
        if (!pre.length && !mid.length && fz.length) fuzzyPick = fz[0];
        /* ask the store about the brand we resolved to, not the nickname/typo ("hitachi" -> "Magic Wand") */
        if (alias) sq = alias._name; else if (fuzzyPick) sq = fuzzyPick._name;
      }
      each(groups, function (g) { g.hidden = !g.querySelector('[data-nhb-item]:not([hidden])'); });
      each(box.querySelectorAll('[data-nhb-idle]'), function (e) { e.hidden = !!q; });
      each(box.querySelectorAll('[data-nhb-results]'), function (e) { e.hidden = !q; });
      each(box.querySelectorAll('[data-nhb-count]'), function (e) { e.textContent = localCount; });
      each(box.querySelectorAll('[data-nhb-plural]'), function (e) { e.hidden = localCount === 1; });
      setEmpty(!!q && localCount === 0 && !smart, raw);
      if (!q) return;

      if (!smart || raw.length < 2) { if (smart) renderSmart(raw, null, fuzzyPick); setEmpty(localCount === 0 && (!smart || smart.hidden), raw); return; }
      /* cached: draw now. Otherwise keep the previous results (dimmed via .is-loading) until the new ones land */
      var key = sq.toLowerCase();
      if (cache[key]) { var anyCached = renderSmart(raw, cache[key], fuzzyPick, sq); setEmpty(localCount === 0 && !anyCached, raw); return; }
      var mine = seq;
      timer = setTimeout(function () {
        if (mine !== seq) return;
        var myCtrl = window.AbortController ? new AbortController() : null;
        ctrl = myCtrl;
        box.classList.add('is-loading');
        suggest(key, myCtrl && myCtrl.signal).then(function (res) {
          if (mine !== seq) return;
          var any = renderSmart(raw, res, fuzzyPick, sq);
          setEmpty(localCount === 0 && !any, raw);
        }).catch(function () {
          if (mine !== seq) return; /* aborted or superseded: the newer query owns the panel */
          clearSmart();
          setEmpty(localCount === 0, raw);
        }).then(function () {
          if (mine === seq) { box.classList.remove('is-loading'); if (ctrl === myCtrl) ctrl = null; }
        });
      }, 220);
    };

    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var raw = input.value.trim();
        var target = best && best._a;
        if (!target && smart && !smart.hidden) target = smart.querySelector('.nhb-smart__dym a, .nhb-smart__chip:not(.nhb-smart__chip--cat)');
        if (target) window.location.href = target.href;
        else if (raw) window.location.href = ROOT + 'search?q=' + encodeURIComponent(raw);
      } else if (e.key === 'Escape' && input.value) {
        e.stopPropagation(); input.value = ''; run();
      }
    });
    run();
  };
  each(document.querySelectorAll('[data-nhb]'), bind);
  document.addEventListener('nh:drawer-panels', function () { each(document.querySelectorAll('[data-nhb]'), bind); });
})();
